import React from "react"
import { useEase } from "../motion"
import { motion } from 'framer-motion'

export const TitleLegacy = props => {
	const duration = 1.24

	const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1.5,
				delayChildren: 1.35,
				staggerChildren: 0.05
			},
		},
	}

	const slideUp = {
		closed: {
			opacity: 0,
			y: "10vh",
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1
			},
		},
		open: {
			opacity: 1,
			y: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: duration,
			},
		},
	}

	const slideDown = {
		closed: {
			opacity: 0,
			y: "-10vh",
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			y: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: duration,
			},
		},
	}

	const slideLeft = {
		closed: {
			opacity: 0,
			x: "-10vw",
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			x: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: duration,
			},
		},
	}

	const slideRight = {
		closed: {
			opacity: 0,
			x: "10vw",
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			x: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: duration,
			},
		},
	}

	return (
		<motion.div
		className="chapter-title"
		variants={parentControl}
		initial="closed"
		animate={props.coverLoaded ? "open" : "closed"}
		exit="closed"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 376.53 230.93"
			>
				<defs>
					<clipPath id="clipPath" transform="translate(-0.16 -3.43)">
						<rect width="349" height="48" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-2"
						transform="translate(-0.16 -3.43)"
					>
						<rect x="359" width="21" height="48" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-3"
						transform="translate(-0.16 -3.43)"
					>
						<rect
							x="47"
							y="55"
							width="333"
							height="60"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clipPath-4"
						transform="translate(-0.16 -3.43)"
					>
						<rect y="112" width="42" height="25" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-5"
						transform="translate(-0.16 -3.43)"
					>
						<rect
							x="21"
							y="141"
							width="204"
							height="35"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clipPath-6"
						transform="translate(-0.16 -3.43)"
					>
						<rect
							x="70"
							y="187"
							width="313"
							height="50"
							fill="none"
						/>
					</clipPath>
				</defs>
				<g id="legacy">
					<g id="group_expanding">
						<g clipPath="url(#clipPath)">
							<motion.g
								id="expanding"
								className="isolation"
								variants={slideUp}

							>
								<g className="isolation">
									<path
										d="M2.6,4.39H27.45V15.73H15.32v3H27v8H15.32V30H27.61v11.5H2.6Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M52.79,32.05l-4,9.43H35L45.26,21.82,36.2,4.39H50L52.79,12l2.75-7.63H69.27l-9,17.43L70.49,41.48H56.71Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M95.45,31.63H91.11v9.85H78.39V4.39H95.45a13.28,13.28,0,0,1,13.36,13.4C108.81,25.16,103,31.63,95.45,31.63ZM93.12,20.71a2.71,2.71,0,0,0,0-5.41h-2v5.41Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M123.65,39.21l-.9,2.27H109.08l19-38,19.07,38.05H133.4l-.9-2.27Zm4.4-11.66L125.77,33h4.4Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M154.71,4.39H165l9.48,9.7V4.39h12.3V43.23L167.11,23.41V41.48h-12.4Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M197.9,4.39h17.38A18.41,18.41,0,0,1,233.51,23a18.18,18.18,0,0,1-18.23,18.49H197.9Zm15.48,25.49a6.92,6.92,0,1,0,0-13.83h-2.76V29.88Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M242.63,4.39h12.72V41.48H242.63Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M266.48,4.39h10.28l9.49,9.7V4.39h12.29V43.23L278.88,23.41V41.48h-12.4Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M332.73,18.54a6.2,6.2,0,0,0-5-2.23,6.7,6.7,0,0,0-6.63,6.78,7,7,0,0,0,7.1,7c3.24,0,4.77-1.38,5.41-2.33h-4.82V20.18h18.12a14.7,14.7,0,0,1,.21,2.81,19.72,19.72,0,0,1-39.43,0c0-10.92,8.91-19.24,19.72-19.24,7.31,0,12.72,2.92,16.32,7.58Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_the">
						<g clipPath="url(#clipPath-2)">
							<motion.g
								id="the"
								className="isolation"
								variants={slideLeft}

							>
								<g className="isolation">
									<path
										d="M371.82,6.71V4H376V14h-4.16V11.27h-9.14V6.71Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M376,17.45V22h-4.69v2H376v4.56h-13.3V24h4.71V22h-4.71V17.45Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M376,32.53v8.91h-4.06V37.09h-1.07v4.18H368V37.09h-1.17V41.5h-4.13v-9Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_legacy">
						<g clipPath="url(#clipPath-3)">
							<motion.g
								id="legacy-2"
								className="isolation"
								variants={slideDown}

							>
								<g className="isolation">
									<path
										d="M51.86,59.28H70.11V95.84H88.42v16.64H51.86Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M102.78,59.28h35.65V75.55H121V79.8h16.73V91.28H121V96h17.64v16.49H102.78Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M187.15,79.57a8.93,8.93,0,0,0-7.23-3.19,9.61,9.61,0,0,0-9.5,9.73,10.05,10.05,0,0,0,10.19,10c4.64,0,6.84-2,7.75-3.34h-6.92V81.93h26a21.14,21.14,0,0,1,.3,4c0,15.12-12.23,27.59-28.27,27.59-15.51,0-28.27-12-28.27-27.59S164,58.37,179.47,58.37c10.49,0,18.24,4.18,23.41,10.87Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M233.58,109.21l-1.29,3.27H212.68l27.21-54.57,27.36,54.57H247.57l-1.3-3.27Zm6.31-16.72-3.27,7.83h6.31Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M299.7,58.37a25,25,0,0,1,11.86,2.73V81.55a13.17,13.17,0,0,0-10.8-5.17c-5.7,0-10.1,4.18-10.1,9.58s4.4,9.57,10.1,9.57a13.17,13.17,0,0,0,10.8-5.16v20.44a25.06,25.06,0,0,1-11.86,2.74c-15.5,0-28.27-12-28.27-27.59S284.2,58.37,299.7,58.37Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M340.44,112.48V90.59L322.27,59.28h20.67L349.4,73l6.85-13.68h20.44L358.6,90.59v21.89Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_of">
						<g clipPath="url(#clipPath-4)">
							<motion.g
								id="of"
								className="isolation"
								variants={slideUp}

							>
								<g className="isolation">
									<path
										d="M10.58,134.88a10.17,10.17,0,1,1,0-20.33,10.17,10.17,0,1,1,0,20.33Zm0-6.78a3.39,3.39,0,0,0,0-6.78,3.39,3.39,0,0,0,0,6.78Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M25.81,114.88H38.94v6H32.53v2.18h6.16v4.51H32.53v6.91H25.81Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_howard">
						<g clipPath="url(#clipPath-5)">
							<motion.g
								id="howard"
								className="isolation"
								variants={slideLeft}

							>
								<g className="isolation">
									<path
										d="M26.94,143.78h9.84v10.13H41V143.78h9.84v28.7H41V162.32H36.78v10.16H26.94Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M73.19,173.06a14.89,14.89,0,1,1,15.25-14.89A15,15,0,0,1,73.19,173.06Zm0-9.92a5,5,0,1,0-4.88-5A4.79,4.79,0,0,0,73.19,163.14Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M117.63,143.78h10.58l-14.72,29.61-3.9-7.59-3.81,7.54L91,143.78h7.42l6.73,13.45.41-.78-6.32-12.67h9.27l4.92,9.76Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M136.78,170.72l-.7,1.76H125.5L140.18,143l14.76,29.44H144.32l-.7-1.76Zm3.4-9-1.76,4.22h3.4Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M170.64,166.42v6.06H160.8v-28.7h11.61c6.8,0,12,4.6,12,11.4a8.71,8.71,0,0,1-3.82,7c2.22,1.31,3.53,3.45,3.53,6.77v3.48H174.5v-3a3,3,0,0,0-3.16-3Zm1.15-13.62h-1.15v5h1.15a2.44,2.44,0,0,0,2.58-2.46A2.48,2.48,0,0,0,171.79,152.8Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M191.88,143.78h13.45a14.24,14.24,0,0,1,14.1,14.39,14.07,14.07,0,0,1-14.1,14.31H191.88Zm12,19.72a5.35,5.35,0,1,0,0-10.7h-2.13v10.7Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
					<g id="group_thurman">
						<g clipPath="url(#clipPath-6)">
							<motion.g
								id="thurman"
								className="isolation"
								variants={slideRight}

							>
								<g className="isolation">
									<path
										d="M81.38,205.06h-8.1V192.58h29.81v12.48h-8v27.42H81.38Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M113.58,192.58h13.68v14.08h5.93V192.58h13.68v39.9H133.19V218.35h-5.93v14.13H113.58Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M158.55,218.46V192.58h13.68v25.71a1.66,1.66,0,0,0,3.31,0V192.58h13.68v25.88c0,9.12-6.73,14.82-15.28,14.82S158.55,227.58,158.55,218.46Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M214.58,224.05v8.43H200.9v-39.9H217c9.47,0,16.65,6.38,16.65,15.85a12.12,12.12,0,0,1-5.3,9.8c3.08,1.83,4.9,4.79,4.9,9.41v4.84H219.94v-4.22a4.16,4.16,0,0,0-4.39-4.21Zm1.6-18.93h-1.6V212h1.6a3.41,3.41,0,0,0,3.59-3.42A3.45,3.45,0,0,0,216.18,205.12Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M264.46,233.68,257.33,223l-1.59,9.46H242.11l8.78-40.76,13.57,20.41L278,191.72l8.78,40.76H273.29L271.7,223Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M308.57,230l-1,2.45H292.9l20.41-40.93,20.52,40.93H319.06l-1-2.45Zm4.74-12.54-2.46,5.87h4.74Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
									<path
										d="M342,192.58H353L363.24,203V192.58h13.22v41.78L355.31,213v19.44H342Z"
										transform="translate(-0.16 -3.43)"
										fill="currentColor"
									/>
								</g>
							</motion.g>
						</g>
					</g>
				</g>
			</svg>
		</motion.div>
	)
}
